import React, {useState, useEffect} from 'react';
import {CSSTransition} from "react-transition-group";
import Layout from "../app/components/ui/layout/Layout";
import AccountingRecapPage from "../app/components/Accounting/Recap/AccountingRecapPage";

const HomeScreen = () => {

    return (
        <Layout>
            <AccountingRecapPage/>
        </Layout>
    );
};

export default HomeScreen;
